import { $api } from '@/shared/api/axiosInstance';

type Props = {
    userId: string;
};

export const deletePhoto = async ({ userId }: Props) => {
    const url = `/api/v1/users/${userId}/avatar`;

    const res = await $api.delete(url);

    return res;
};
